import { Container, FormContainer, LoginBox, Logo } from "./styles";
import capivara from "../../../../assets/images/capivara.png";
import { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "../../../../components/inputs";
import { Page } from "../../../../components/page-base";
import { toast } from "react-toastify";
import { LoginService } from "../../services";
import { validatePassword } from "../../../../utils/validatePassword";

export const SetNewPassword: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState<string>("");
  const [passwordConfirm, setPasswordConfirm] = useState<string>("");
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isTokenValid, setIsTokenValid] = useState<boolean>(false);

  const hasVerifiedToken = useRef<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsDisabled(true);
    try {
      const response = await LoginService.changePassword(password, token!);
      if (response.success) {
        toast.success(response.message);
        setTimeout(() => {
          navigate("/");
        }, 1000);
      } else {
        toast.error("Erro ao redefinir senha.");
        setIsDisabled(false);
      }
    } catch (error) {
      console.error(error);
      toast.error("Erro inesperado ao redefinir senha.");
      setIsDisabled(false);
    }
  };

  useMemo(() => {
    if (
      password &&
      passwordConfirm &&
      password === passwordConfirm &&
      isTokenValid &&
      validatePassword(password) &&
      validatePassword(passwordConfirm)
    ) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [password, passwordConfirm, isTokenValid]);

  useEffect(() => {
    if (token && !hasVerifiedToken.current) {
      hasVerifiedToken.current = true;
      const checkToken = async () => {
        try {
          const result = await LoginService.verifyPasswordResetToken(token);
          if (result.success) {
            setIsTokenValid(true);
          } else {
            toast.error(result.message);
          }
        } catch (error: unknown) {
          console.error("Erro ao verificar o token:", error);
          toast.error("Erro ao verificar o token.");
        }
      };
      checkToken();
    }
  }, [token]);

  return (
    <Container>
      <LoginBox>
        <Logo>
          <img src={capivara} alt="Logo" />
        </Logo>
        <form onSubmit={handleSubmit}>
          <FormContainer>
            <Input.Password
              label="Senha para acesso:"
              placeholder=""
              setValue={setPassword}
              value={password}
              required
              error={!validatePassword(password)}
              errorMessage="A senha deve possuir pelo menos 8 caracteres"
            />
            <Input.Password
              label="Confirmar senha"
              placeholder=""
              setValue={setPasswordConfirm}
              value={passwordConfirm}
              required
              error={password != passwordConfirm}
              errorMessage="As senhas devem ser iguais"
            />
          </FormContainer>

          <Page.Button
            type="submit"
            label="Atualizar senha"
            disabled={isDisabled}
          />
        </form>
      </LoginBox>
    </Container>
  );
};
